import React, { useCallback, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography, Box } from '@material-ui/core';
import { useDropzone } from 'react-dropzone';
import FileUploadIcon from '../../Assets/fileUpload.jpg';
import { useTranslation } from 'react-i18next';
import KenCard from '../KenCard/index';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import { createJob } from '../../Utils/apiServices';
import KenButton from '../../global_components/KenButton';
import KenLoader from '../../Components/KenLoader/index';
import KenSnackbar from '../../Components/KenSnackbar/index';

const useStyles = makeStyles((theme) => ({
  FileUploadWrap: {
    border: '1.5px dotted',
  },
  FileUploadContainer: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 100,
    cursor: 'pointer',
    justifyContent: 'center',
  },
  FileUploadImg: {
    width: 26,
  },
  uploadLabel: {
    marginLeft: 10,
    fontSize: 20,
    // fontWeight: "bold",
    color: theme.palette.KenColors.neutral400,
  },
  FileUploadList: {
    marginTop: 30,
  },
  FileUploadListView: {
    color: theme.palette.KenColors.KenBlack,
    fontSize: 14,
  },
  FileUploadButton: {
    textAlign: 'right',
  },
}));

export default function FileUpload(props) {
  const { setReloadJobs, reloadJobs } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);

  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  //-------------------

  const [myFiles, setMyFiles] = useState([]);

  const onDrop = useCallback(
    (acceptedFiles) => {
      setMyFiles([...acceptedFiles]);
    },
    [myFiles]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: '.xls,.xlsx',
  });

  const removeFile = (file) => () => {
    const newFiles = [...myFiles];
    newFiles.splice(newFiles.indexOf(file), 1);
    setMyFiles(newFiles);
  };

  const uploadJob = (acceptedFiles) => {
    setLoading(true);
    const fileUploadPayload = {
      file: acceptedFiles[0],
    };
    createJob(fileUploadPayload)
      .then((res) => {
        handleSnackbarOpen('success', t('messages:file_upload_success'));
        setTimeout(() => {
          setLoading(false);
          setMyFiles([]);
        }, 500);
        setReloadJobs(!reloadJobs);
      })
      .catch((err) => {
        setLoading(false);
        handleSnackbarOpen('success', t('messages:file_upload_fail'));
        console.log('error in file upload', err);
      });
  };

  const files = myFiles.map((file) => (
    <li key={file.path} style={{ fontSize: 15 }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {file.path}
        <ClearOutlinedIcon
          onClick={removeFile(file)}
          style={{ marginLeft: 10, cursor: 'pointer', width: 18, marginTop: 2 }}
        />
      </div>
    </li>
  ));

  return (
    <Grid className={classes.root}>
      <KenCard>
        <div
          variant="contained"
          component="label"
          className={classes.FileUploadWrap}
          data-testid="upload-button"
        >
          <div
            {...getRootProps()}
            style={{
              width: '100%',
            }}
          >
            <input {...getInputProps()} />
            <div className={classes.FileUploadContainer}>
              <img
                src={FileUploadIcon}
                className={classes.FileUploadImg}
                data-testid="upload-image"
              ></img>
              <Typography className={classes.uploadLabel}>
                {t('messages:files_Upload')}
              </Typography>
            </div>
          </div>
        </div>
        <div className={classes.FileUploadList}>
          {files.length > 0 && (
            <Typography className={classes.FileUploadLabel}>
              {t('labels:files')}:
            </Typography>
          )}
          <ul>{files}</ul>
          {files.length > 0 && (
            <Box className={classes.FileUploadButton}>
              <KenButton
                label={t('labels:upload')}
                variant="primary"
                onClick={() => uploadJob(myFiles)}
              />
            </Box>
          )}
        </div>
        {loading && <KenLoader />}
        <KenSnackbar
          message={snackbarMessage}
          severity={snackbarSeverity}
          autoHideDuration={4000}
          open={openSnackbar}
          handleSnackbarClose={handleSnackbarClose}
          position="Bottom-Right"
        />
      </KenCard>
    </Grid>
  );
}
